module.exports = __webpack_public_path__ + "img/visits.a37be732.svg";